<div class="ps-d-flex ps-align-items-center ps-justify-content-center ps-w-100 ps-h-100">
  <qr-code [value]="authSvc.currentUser?.user?.userId??undefined" size="450" errorCorrectionLevel="M"></qr-code>
</div>